/* Product card hover image: show the 2nd photo of the SELECTED variant.
   Data: variant.image2 (media directly after the variant's featured media),
   rendered into [data-quick-add-variants] by snippets/quick-add-card.liquid.
   Falls back to the theme's original 2nd image when a variant has none. */
(function () {
  'use strict';
  if (window.__celebrateCardHover) return;
  window.__celebrateCardHover = true;

  function toArray(l) { return Array.prototype.slice.call(l || []); }

  function apply(root) {
    if (!root) return;
    var card = root.querySelector('[data-quick-add-card]');
    var json = root.querySelector('[data-quick-add-variants]');
    var img = root.querySelector('.product-item__image--two img');
    if (!card || !json || !img) return;
    if (!img.__orig) img.__orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    if (!root.__chVariants) {
      try { root.__chVariants = JSON.parse(json.textContent); } catch (e) { root.__chVariants = []; }
    }
    var id = parseInt(card.getAttribute('data-current-variant-id'), 10);
    var v = null;
    for (var i = 0; i < root.__chVariants.length; i++) {
      if (root.__chVariants[i].id === id) { v = root.__chVariants[i]; break; }
    }
    if (v && v.image2) {
      if (img.getAttribute('src') !== v.image2) {
        img.setAttribute('srcset', '');
        img.setAttribute('src', v.image2);
      }
    } else if (img.getAttribute('src') !== img.__orig.src) {
      img.setAttribute('src', img.__orig.src);
      if (img.__orig.srcset != null) img.setAttribute('srcset', img.__orig.srcset);
    }
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-quick-add-root]')).forEach(apply);
  }

  function boot() {
    initAll(document);
    // Runs after the quick-add handler has updated data-current-variant-id.
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-quick-add-value]');
      if (!chip) return;
      var root = chip.closest('[data-quick-add-root]');
      setTimeout(function () { apply(root); }, 0);
    });
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('[data-quick-add-root]')) apply(n);
            if (n.querySelectorAll) initAll(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
